import { render, staticRenderFns } from "./Artifact.vue?vue&type=template&id=45d8625a&"
import script from "./Artifact.vue?vue&type=script&lang=js&"
export * from "./Artifact.vue?vue&type=script&lang=js&"
import style0 from "./Artifact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports